import actions from "@/store/review/actions";
import state from "@/store/review/states";
import mutations from "@/store/review/mutations";

const ReviewModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default ReviewModule;